export type AnimationStateToProperties<T> = {
	initial: T,
	enter: T,
	exit: T,
}

export type AnimatableElement = SVGElement | HTMLElement;

export type AnimationState = keyof AnimationStateToProperties<any>;

export type DurationDetailOptions = Partial<AnimationStateToProperties<number>> | AnimationStateToProperties<number>;
export type DurationProp = DurationDetailOptions | number | ((state: AnimationState) => number);

export type ClassNamesOptions = AnimationStateToProperties<string>;

export type ClassNamesProp = ClassNamesOptions | ((state: AnimationState) => string);

export type StateChangedCallback = (state: AnimationState, element: AnimatableElement) => Function | void;


export type Duration = 'fastest' | 'fast' | 'common' | 'slow' | number;

const durationMap = {
	fastest: 100,
	fast: 150,
	common: 200,
	slow: 300,
};

export function getDuration(duration: Duration): number {
	if(typeof duration === 'number') {
		return duration;
	} else {
		const fromMap = durationMap[duration];
		return fromMap || 0;
	}
}
